import get from 'lodash/get';
/** import third-party libraries in the section above, Sort Lines Ascending */

import { validateDraft_activate as validateDraft } from './services';
import { getDefaults } from './services';
import c from 'common/constants/flux-events';
/** import single application imports in the section above, Sort Lines Ascending */

const initialState = {
    draft: { ...getDefaults('payload_formData') },
    isDraftValid: false,
    errors: [],
    showErrors: false,
    isLoading: false,
    isOpen: false,
    isSubmiting: false,
    isDirty: false,
    fetchError: null,
};

export const NAME = 'activate';

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case c.ACTIVATION__DRAFT__OPEN: {
            return {
                ...state,
                isLoading: true,
                isOpen: true,
                fetchError: null,
            };
        }

        case c.ACTIVATION__DRAFT__FETCH__SUCCESS: {
            return {
                ...state,
            };
        }

        case c.ACTIVATION__DRAFT__FETCH__FAIL: {
            // Token invalid/expired: show inline error instead of the activation form.
            return {
                ...state,
                isLoading: false,
                fetchError: action.payload.fetchError,
            };
        }

        case c.ACTIVATION__DRAFT__INIT: {
            const activateAttr = get(action, 'payload.activateAttr');
            const activateDraft = {
                ...state.draft,
                ...activateAttr,
            };

            const errors = validateDraft(activateDraft);

            const activation_token = get(action, 'payload.activation_token');
            const token_default = getDefaults('payload_nonformData').activation_token;

            return {
                ...state,
                errors,
                isDraftValid: errors.length === 0,
                draft: activateDraft,
                isLoading: false,
                isDirty: false,
                activation_token: activation_token ? activation_token : token_default,
            };
        }
        case c.ACTIVATION__DRAFT__UPDATE: {
            const { formData } = action.payload;

            const nextDraft = {
                ...state.draft,
                ...formData,
            };

            const errors = validateDraft(nextDraft);

            return {
                ...state,
                draft: nextDraft,
                isDirty: true,
                errors,
                isDraftValid: errors.length === 0,
            };
        }

        case c.ACTIVATION__DRAFT__SHOW_ERRORS: {
            return {
                ...state,
                showErrors: true,
            };
        }

        case c.ACTIVATION__DRAFT__SUBMIT: {
            return {
                ...state,
                isSubmiting: true,
            };
        }

        case c.ACTIVATION__DRAFT__SUBMIT_FAIL: {
            // Normalize API errors so downstream selector/rendering always receives
            // a consistent list of { field, message } objects.
            const errorList = Array.isArray(action.error)
                ? action.error
                : action.error
                ? [action.error]
                : [];
            const errors = errorList.map(error => {
                // Some APIs return string[] for generic failures.
                if (typeof error === 'string') {
                    return {
                        field: '',
                        message: error,
                    };
                }

                // Guard against null/primitive values in mixed error payloads.
                if (!error || typeof error !== 'object') {
                    return {
                        field: '',
                        message: 'An error has occurred.',
                    };
                }

                return {
                    // Empty field is intentional for non-field/global validation errors.
                    field: typeof error.field === 'string' ? error.field : '',
                    message:
                        typeof error.message === 'string' && error.message
                            ? error.message
                            : 'An error has occurred.',
                };
            });

            return {
                ...state,
                errors,
                showErrors: true,
                isLoading: false,
                isSubmiting: false,
                isDraftValid: false,
            };
        }

        case c.ACTIVATION__DRAFT__SUBMIT_SUCCESS:
            return {
                ...state,
                isSubmiting: false,
            };

        case c.ACTIVATION__DRAFT__CLOSE: {
            return {
                ...initialState,
            };
        }

        default:
            return state;
    }
}
